import React, { useState } from "react";
import { Box, Typography, Button, Paper, Avatar, Divider } from "@mui/material";
import TopBar from "../globalComponents/topbar";
import Footer from "../globalComponents/footer";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"; // for "In Progress"
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import PercentIcon from "@mui/icons-material/Percent";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div
				style={{
					height: 1000,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 200,
					}}>
					<TopBar />
					<span
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 110,
						}} >
						{"Lessons"}
					</span>
					<div
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 41,
						}}>
						<span
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 36,
							}} >
							{"Explore all lessons."}
						</span>
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 110,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"List of Lessons"}
							</span>
							<div
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 28,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ka1b0uw8_expires_30_days.png"}
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Lesson List"}
								</span>
							</div>
							{/* <div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											paddingTop: 21,
											paddingBottom: 4,
											gap: 7,
											backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/878n4eyy_expires_30_days.png)',
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jdgt1dv8_expires_30_days.png"} 
												style={{
													width: 19,
													height: 19,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												marginLeft: 25,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cjl5npgu_expires_30_days.png"} 
												style={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 8,
													fontWeight: "bold",
												}} >
												{"10:45"}
											</span>
										</div>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Understanding Market Research"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Video (10 min)"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y5n4e9l9_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 113,
										paddingRight: 113,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Review Lesson"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ficcw0jd_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div> */}
							<Paper
								elevation={1}
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									bgcolor: "#FFFFFF",
									borderRadius: 2,
									border: "1px solid #E6E6E6",
									py: 2,
									mb: 2,
									gap: 2,
									boxShadow: "0px 1px 2px #00000008",
								}}
							>
								{/* Top Section */}
								<Box
									sx={{
										display: "flex",
										alignItems: "flex-start",
										ml: 2,
										gap: 1.5,
									}}
								>
									{/* Thumbnail with overlay */}
									<Box
										sx={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											pt: 2.6,
											pb: 0.5,
											gap: 0.8,
											backgroundImage:
												"url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/878n4eyy_expires_30_days.png)",
											backgroundSize: "cover",
											backgroundPosition: "center",
											borderRadius: 1,
											overflow: "hidden",
											width: 60,
											height: 60,
											position: "relative",
										}}
									>
										{/* Play icon */}
										<Box
											sx={{
												alignSelf: "stretch",
												display: "flex",
												justifyContent: "center",
											}}
										>
											<Box
												component="img"
												src="https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jdgt1dv8_expires_30_days.png"
												sx={{
													width: 19,
													height: 19,
													objectFit: "fill",
												}}
											/>
										</Box>

										{/* Time badge */}
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												pr: 0.5,
												ml: 3,
												gap: 0.5,
											}}
										>
											<Box
												component="img"
												src="https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cjl5npgu_expires_30_days.png"
												sx={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<Typography sx={{ color: "#FFFFFF", fontSize: 8, fontWeight: "bold" }}>
												10:45
											</Typography>
										</Box>
									</Box>

									{/* Lesson Info */}
									<Box
										sx={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 1,
										}}
									>
										<Typography sx={{ color: "#010101", fontSize: 14, fontWeight: "bold" }}>
											Understanding Market Research
										</Typography>

										<Typography sx={{ color: "#979797", fontSize: 12, fontWeight: "bold" }}>
											Lesson Type: Video (10 min)
										</Typography>

										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												pr: 0.5,
												gap: 0.5,
											}}
										>
											<Box
												component="img"
												src="https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y5n4e9l9_expires_30_days.png"
												sx={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<Typography sx={{ color: "#0BBB0D", fontSize: 11, fontWeight: "bold" }}>
												Completed
											</Typography>
										</Box>
									</Box>
								</Box>

								{/* Review Button */}
								<Button
									variant="contained"
									disableElevation
									sx={{
										alignSelf: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 1,
										py: 1,
										px: 10,
										mx: 2,
										textTransform: "none",
										fontSize: 12,
										fontWeight: "bold",
										"&:hover": {
											background: "linear-gradient(180deg, #5CC9F2, #009ED9)",
										},
									}}
									endIcon={
										<Box
											component="img"
											src="https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ficcw0jd_expires_30_days.png"
											sx={{
												width: 11,
												height: 11,
												objectFit: "fill",
											}}
										/>
									}
								>
									Review Lesson
								</Button>
							</Paper>
							{/* <div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yuv7oo1d_expires_30_days.png"}
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Business Planning Strategies"}
										</span>
										<span
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/shjpjn1y_expires_30_days.png"}
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span
												style={{
													color: "#EEBD10",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"In Progress"}
											</span>
										</div>
									</div>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 130,
										paddingRight: 130,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s1pcyym9_expires_30_days.png"}
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div> */}
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									bgcolor: "#FFFFFF",
									borderRadius: 2,
									border: "1px solid #E6E6E6",
									py: 2,
									mb: 2,
									gap: 2,
									boxShadow: "0px 1px 2px #00000008",
								}}
							>
								{/* Top section */}
								<Box sx={{ display: "flex", alignItems: "flex-start", ml: 2, gap: 1.5 }}>
									{/* Lesson thumbnail */}
									<Avatar
										variant="rounded"
										sx={{ width: 61, height: 61, bgcolor: "#E0F7FA" }}
									>
										<DescriptionIcon sx={{ color: "#00AEEF", fontSize: 32 }} />
									</Avatar>

									{/* Lesson details */}
									<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
										<Typography sx={{ color: "#010101", fontSize: 14, fontWeight: "bold" }}>
											Business Planning Strategies
										</Typography>

										<Typography sx={{ color: "#979797", fontSize: 12, fontWeight: "bold" }}>
											Lesson Type: Text Lesson
										</Typography>

										<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
											<AutoAwesomeIcon sx={{ color: "#EEBD10", fontSize: 14 }} />
											<Typography sx={{ color: "#EEBD10", fontSize: 11, fontWeight: "bold" }}>
												In Progress
											</Typography>
										</Box>
									</Box>
								</Box>

								{/* Action button */}
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 1,
										py: 1,
										px: 8,
										mx: 2,
										gap: 0.5,
										justifyContent: "center",
									}}
								>
									<Typography sx={{ color: "#FFFFFF", fontSize: 12, fontWeight: "bold" }}>
										Continue
									</Typography>
									<PlayArrowIcon sx={{ color: "#FFFFFF", fontSize: 16 }} />
								</Box>
							</Box>
							{/* <div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 24,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f3kk739c_expires_30_days.png"}
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o2nw8bdo_expires_30_days.png"}
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Not Started"}
											</span>
										</div>
									</div>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 127,
										paddingRight: 127,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Start now"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r1069fwq_expires_30_days.png"}
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div> */}
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									bgcolor: "#FFFFFF",
									borderRadius: 2,
									border: "1px solid #E6E6E6",
									py: 2,
									mb: 3,
									gap: 2,
									boxShadow: "0px 1px 2px #00000008",
								}}
							>
								{/* Top section */}
								<Box sx={{ display: "flex", alignItems: "flex-start", ml: 2, gap: 1.5 }}>
									{/* Thumbnail */}
									<Avatar
										variant="rounded"
										sx={{ width: 61, height: 61, bgcolor: "#E3F2FD" }}
									>
										<DescriptionIcon sx={{ color: "#00AEEF", fontSize: 32 }} />
									</Avatar>

									{/* Lesson Info */}
									<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
										<Typography sx={{ color: "#010101", fontSize: 14, fontWeight: "bold" }}>
											Financial Projections for Startups
										</Typography>

										<Typography sx={{ color: "#979797", fontSize: 12, fontWeight: "bold" }}>
											Lesson Type: Text Lesson
										</Typography>

										<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
											<HourglassEmptyIcon sx={{ color: "#6C6C6C", fontSize: 14 }} />
											<Typography sx={{ color: "#6C6C6C", fontSize: 11, fontWeight: "bold" }}>
												Not Started
											</Typography>
										</Box>
									</Box>
								</Box>

								{/* Action Button */}
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 1,
										py: 1,
										px: 8,
										mx: 2,
										gap: 0.5,
										justifyContent: "center",
									}}
								>
									<Typography sx={{ color: "#FFFFFF", fontSize: 12, fontWeight: "bold" }}>
										Start now
									</Typography>
									<PlayArrowIcon sx={{ color: "#FFFFFF", fontSize: 16 }} />
								</Box>
							</Box>
							<button
								style={{
									display: "flex",
									alignItems: "center",
									background: "#E6F7FD",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 109,
									paddingRight: 109,
									gap: 9,
									textAlign: "left",
								}}
								onClick={() => alert("Pressed!")}>
								<span
									style={{
										color: "#00AEEF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Browse All Lessons"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ol9l4o2f_expires_30_days.png"}
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</button>
						</div>
						<div
							style={{
								width: 1,
								height: 680,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						{/* <div
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Lesson Details"}
							</span>
							<div
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
								}}>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 3,
										marginRight: 255,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6a0b72bh_expires_30_days.png"}
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Details"}
									</span>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 2,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/78tdnx9b_expires_30_days.png"}
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Title & Summary"}
									</span>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 17,
									gap: 32,
								}}>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										paddingTop: 87,
										paddingBottom: 20,
										paddingLeft: 18,
										paddingRight: 18,
										gap: 52,
										backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7l2jr1l8_expires_30_days.png)',
										backgroundSize: "cover",
										backgroundPosition: "center",
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/unew87nz_expires_30_days.png"}
										style={{
											width: 44,
											height: 44,
											objectFit: "fill",
										}}
									/>
									<div
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sofd3per_expires_30_days.png"}
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"10:45"}
											</span>
										</div>
										<div
											style={{
												width: 46,
												alignSelf: "stretch",
											}}>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ysv57lxn_expires_30_days.png"}
											style={{
												width: 14,
												height: 14,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Understanding Market Research"}
									</span>
									<span
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 19,
											width: 294,
										}} >
										{"This lesson covers essential market research techniques to identify customer needs and analyze competition."}
									</span>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FEF0E9",
											borderRadius: 8,
											paddingTop: 10,
											paddingBottom: 10,
											paddingLeft: 12,
											paddingRight: 12,
											marginBottom: 12,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g36ensyy_expires_30_days.png"}
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												gap: 4,
											}}>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
												}} >
												{"Completion Time"}
											</span>
											<span
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Approx. 15 min"}
											</span>
										</div>
									</div>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 8,
											paddingTop: 10,
											paddingBottom: 10,
											paddingLeft: 12,
											paddingRight: 12,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/659t8ylh_expires_30_days.png"}
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<div
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 4,
											}}>
											<span
												style={{
													color: "#6C6C6C",
													fontSize: 10,
												}} >
												{"Lesson Progress"}
											</span>
											<span
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Completed 25%"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<span
								style={{
									color: "#6C6C6C",
									fontSize: 12,
								}} >
								{"Lesson Type"}
							</span>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 10,
								}}>
								<span
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginTop: 12,
										marginRight: 305,
									}} >
									{"Video Lesson"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w70ns6mt_expires_30_days.png"}
									style={{
										width: 9,
										height: 22,
										marginRight: 2,
										objectFit: "fill",
									}}
								/>
								<span
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Downloadable Resources"}
								</span>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									gap: 32,
								}}>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 23,
									}}>
									<div
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 12,
										}}>
										<span
											style={{
												color: "#6C6C6C",
												fontSize: 12,
											}} >
											{"Lesson"}
										</span>
										<span
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Conducting Market Research"}
										</span>
									</div>
								</div>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 20,
									}}>
									<button
										style={{
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 8,
											border: "none",
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 52,
											paddingRight: 52,
											textAlign: "left",
										}}
										onClick={() => alert("Pressed!")}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ed4nrih0_expires_30_days.png"}
											style={{
												width: 17,
												height: 17,
												marginRight: 6,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 8,
											}} >
											{"Download PDF Guide"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xs9l7x25_expires_30_days.png"}
											style={{
												width: 7,
												height: 11,
												objectFit: "fill",
											}}
										/>
									</button>
									<div
										style={{
											display: "flex",
											alignItems: "flex-start",
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/j2qhebyv_expires_30_days.png"}
											style={{
												width: 9,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Ask Giia (AI Mentor)"}
										</span>
									</div>
								</div>
							</div>
							<div
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
								}}>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 12,
										paddingBottom: 12,
										paddingLeft: 28,
										paddingRight: 28,
										marginRight: 16,
										gap: 6,
									}}>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 2,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uei6bgcz_expires_30_days.png"}
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#F36421",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Have a question? Ask Giia!"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y5srei1y_expires_30_days.png"}
										style={{
											width: 7,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
						</div> */}
						<Box sx={{ display: "flex", flexDirection: "column", mt: 3 }}>
							{/* Section Header */}
							<Typography sx={{ color: "#979797", fontSize: 16, fontWeight: "bold", mb: 2 }}>
								Lesson Details
							</Typography>
							<Divider sx={{ width: 691, mb: 2, borderColor: "#E6E6E6" }} />

							{/* Subheaders */}
							<Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
								<Box sx={{ display: "flex", alignItems: "center", mr: 30, gap: 1 }}>
									<MenuBookIcon sx={{ color: "#00AEEF" }} />
									<Typography sx={{ fontSize: 18, fontWeight: "bold", color: "#010101" }}>
										Lesson Details
									</Typography>
								</Box>
								<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
									<DescriptionIcon sx={{ color: "#00AEEF" }} />
									<Typography sx={{ fontSize: 18, fontWeight: "bold", color: "#010101" }}>
										Lesson Title & Summary
									</Typography>
								</Box>
							</Box>

							{/* Lesson Card */}
							<Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 4 }}>
								{/* Thumbnail / Video */}
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										bgcolor: "#00AEEF",
										borderRadius: 2,
										p: 2,
										backgroundImage: "linear-gradient(180deg, #00AEEF, #6BD0F6)",
										color: "#fff",
									}}
								>
									<PlayCircleFilledWhiteIcon sx={{ fontSize: 44 }} />
									<Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
										<AccessTimeIcon sx={{ fontSize: 14, color: "#fff" }} />
										<Typography sx={{ fontSize: 12, fontWeight: "bold" }}>10:45</Typography>
									</Box>
								</Box>

								{/* Lesson Info */}
								<Box sx={{ display: "flex", flexDirection: "column" }}>
									<Typography sx={{ fontSize: 18, fontWeight: "bold", color: "#010101", mb: 1 }}>
										Understanding Market Research
									</Typography>
									<Typography sx={{ fontSize: 14, color: "#6C6C6C", mb: 2, width: 300 }}>
										This lesson covers essential market research techniques to identify customer
										needs and analyze competition.
									</Typography>

									{/* Completion Time */}
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											bgcolor: "#FEF0E9",
											borderRadius: 2,
											p: 1.5,
											mb: 1.5,
											gap: 1,
										}}
									>
										<AccessTimeIcon sx={{ color: "#F36421", fontSize: 25 }} />
										<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
											<Typography sx={{ color: "#6C6C6C", fontSize: 10 }}>
												Completion Time
											</Typography>
											<Typography sx={{ color: "#2C2C2C", fontSize: 12, fontWeight: "bold" }}>
												Approx. 15 min
											</Typography>
										</Box>
									</Box>

									{/* Lesson Progress */}
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											bgcolor: "#E6F7FD",
											borderRadius: 2,
											p: 1.5,
											gap: 1,
										}}
									>
										<PercentIcon sx={{ color: "#00AEEF", fontSize: 25 }} />
										<Box sx={{ display: "flex", flexDirection: "column" }}>
											<Typography sx={{ color: "#6C6C6C", fontSize: 10 }}>
												Lesson Progress
											</Typography>
											<Typography sx={{ color: "#6BD0F6", fontSize: 12, fontWeight: "bold" }}>
												Completed 25%
											</Typography>
										</Box>
									</Box>
								</Box>
							</Box>

							{/* Lesson Type */}
							<Typography sx={{ color: "#6C6C6C", fontSize: 12 }}>Lesson Type</Typography>
							<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
								<Typography
									sx={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										mt: 1.5,
										mr: 30,
									}}
								>
									Video Lesson
								</Typography>
								<OndemandVideoIcon sx={{ color: "#00AEEF" }} />
								<Typography sx={{ fontSize: 18, fontWeight: "bold", color: "#010101", ml: 1 }}>
									Downloadable Resources
								</Typography>
							</Box>

							{/* Download Section */}
							<Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 4 }}>
								<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
									<Divider sx={{ width: 362, borderColor: "#E6E6E6" }} />
									<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
										<Typography sx={{ color: "#6C6C6C", fontSize: 12 }}>Lesson</Typography>
										<Typography sx={{ color: "#2C2C2C", fontSize: 14, fontWeight: "bold" }}>
											Conducting Market Research
										</Typography>
									</Box>
								</Box>

								<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
									<Button
										variant="contained"
										sx={{
											bgcolor: "#E6F7FD",
											color: "#00AEEF",
											borderRadius: 2,
											textTransform: "none",
											fontWeight: "bold",
											px: 6,
											py: 1.5,
											"&:hover": { bgcolor: "#d4f2fa" },
										}}
										onClick={() => alert("Pressed!")}
										startIcon={<CloudDownloadIcon />}
										endIcon={<KeyboardArrowRightIcon />}
									>
										Download PDF Guide
									</Button>

									<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
										<QuestionAnswerIcon sx={{ color: "#00AEEF" }} />
										<Typography sx={{ fontSize: 18, fontWeight: "bold", color: "#010101" }}>
											Ask Giia (AI Mentor)
										</Typography>
									</Box>
								</Box>
							</Box>

							{/* Ask Giia Footer */}
							<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										bgcolor: "#FEF0E9",
										borderRadius: 2,
										px: 3,
										py: 1.5,
										mr: 2,
										gap: 1,
									}}
								>
									<QuestionAnswerIcon sx={{ color: "#F36421" }} />
									<Typography sx={{ color: "#F36421", fontSize: 14, fontWeight: "bold" }}>
										Have a question? Ask Giia!
									</Typography>
									<KeyboardArrowRightIcon sx={{ color: "#F36421", fontSize: 16 }} />
								</Box>
							</Box>
						</Box>
					</div>
				</div>

			</div>
			<Footer />
		</div>
	)
}